module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticStyle: {
      "width": "100%",
      "padding": "20px"
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-right",
    staticStyle: {
      "padding": "14px"
    },
    attrs: {
      "xs3": ""
    }
  }, [_vm._v("poorly characterised")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    style: ({
      border: '3px solid' + _vm.getColorPctHex(_vm.score.substring(0, _vm.score.indexOf('%'))),
      'padding': '0 5px',
      'border-radius': '2px'
    })
  }, [_c('v-progress-linear', {
    attrs: {
      "value": _vm.score.substring(0, _vm.score.indexOf('%')),
      "height": "15",
      "color-front": _vm.getColorPct(_vm.score.substring(0, _vm.score.indexOf('%'))),
      "color-back": "blue-grey"
    }
  })], 1), _vm._v(" "), _c('div', {
    style: ({
      color: _vm.getColorPctHex(_vm.score.substring(0, _vm.score.indexOf('%'))),
      'font-weight': 600
    })
  }, [_vm._v(_vm._s(_vm.score))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-left",
    staticStyle: {
      "padding-top": "14px"
    },
    attrs: {
      "xs3": ""
    }
  }, [_vm._v("well characterised")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-586794fb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prb-target/prb-target-top/prb-characterisation/PrbCharacterisation.vue
// module id = 560
// module chunks = 1